export default __webpack_public_path__ + "static/media/Magical Strings 2018 (99 of 264).43f26809.jpg";